import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

interface CoverPlayIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const CoverPlayIcon: FunctionComponent<CoverPlayIconProps> = ({
  className,
  ...props
}) => {
  return (
    <svg
      className={className || ''}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 7.39 8.53"
      width={8}
      height={10}
      {...props}
    >
      <path d="M0,2C0,.41,1.78-.55,3.11.34l3.39,2.26c1.19.79,1.19,2.54,0,3.33l-3.39,2.26c-1.33.89-3.11-.07-3.11-1.66V2Z" />
    </svg>
  );
};

export default styled(CoverPlayIcon)`
  fill: ${({ theme }) => theme.colors.background};
`;
